/**
 * Outfitter Definitions
 * Shops where players BUY gear, tackle, boats, etc.
 */

import { OutfitterDefinition, OutfitterType, ShopCategory } from '@/types';

/**
 * Lakeside Tackle - Starter outfitter in Mountain Lake
 * Unlocked by default, basic gear
 */
export const LAKESIDE_TACKLE: OutfitterDefinition = {
  id: 'lakeside_tackle',
  category: ShopCategory.OUTFITTER,
  subtype: OutfitterType.TACKLE_SHOP,
  name: "Lakeside Tackle Shop",
  description: "Your one-stop shop for fishing gear and supplies.",
  zoneId: 'mountain_lake',

  // Unlocked by default
  unlockedByDefault: true,

  // Inventory
  inventory: [
    // Tier 1 — Starting gear (free)
    { equipmentId: 'rod_wooden', price: 0, stock: -1 },
    { equipmentId: 'reel_basic', price: 0, stock: -1 },
    { equipmentId: 'line_mono', price: 0, stock: -1 },

    // Tackle (bobbers, weights, lures)
    { equipmentId: 'bobber_basic', price: 0, stock: -1 },
    { equipmentId: 'lure_spinner', price: 0, stock: -1 },
    { equipmentId: 'weight_split', price: 30, stock: -1 },
    { equipmentId: 'bobber_slip', price: 60, stock: -1 },
    { equipmentId: 'weight_sinker', price: 80, stock: -1 },
    { equipmentId: 'lure_crankbait', price: 120, stock: -1 },

    // Bait (consumable, sold in stacks of 10)
    { equipmentId: 'bait_worms', price: 15, stock: -1 },
    { equipmentId: 'bait_crickets', price: 25, stock: -1 },
    { equipmentId: 'bait_minnows', price: 40, stock: -1 },

    // Tier 2 — Early upgrades
    { equipmentId: 'rod_reinforced', price: 50, stock: -1 },
    { equipmentId: 'reel_spinning', price: 75, stock: -1 },
    { equipmentId: 'line_braided', price: 80, stock: -1 },

    // Tier 3 — Advanced gear
    { equipmentId: 'rod_fiberglass', price: 150, stock: -1 },
    { equipmentId: 'reel_baitcaster', price: 200, stock: -1 },

    // Traps
    { equipmentId: 'trap_wire_basket', price: 75, stock: -1 },
    { equipmentId: 'trap_crawdad_pot', price: 200, stock: -1 },
    { equipmentId: 'trap_deluxe_pot', price: 450, stock: -1 },

    // Trap bait (consumable)
    { equipmentId: 'trap_bait_chicken_liver', price: 10, stock: -1 },
    { equipmentId: 'trap_bait_fish_heads', price: 20, stock: -1 },
    { equipmentId: 'trap_bait_herring_chunks', price: 35, stock: -1 },

    // Fly rods
    { equipmentId: 'rod_fly_bamboo', price: 120, stock: -1 },
    { equipmentId: 'rod_fly_graphite', price: 250, stock: -1 },
    { equipmentId: 'rod_fly_carbon', price: 500, stock: -1 },

    // Fly patterns (consumable)
    { equipmentId: 'fly_adams', price: 20, stock: -1 },
    { equipmentId: 'fly_woolly_bugger', price: 25, stock: -1 },
    { equipmentId: 'fly_elk_hair_caddis', price: 22, stock: -1 },
    { equipmentId: 'fly_royal_wulff', price: 45, stock: -1 },
  ],

  // Visual
  npcName: "Old Pete",
  npcDialogue: [
    "Welcome to the shop!",
    "Looking for quality gear?",
    "I've got what you need.",
    "Been fishing these waters for 40 years.",
  ],
};

/**
 * All outfitter definitions
 */
export const OUTFITTER_DEFINITIONS: OutfitterDefinition[] = [
  LAKESIDE_TACKLE,
];
